import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-bp-mui-dropdown',
  templateUrl: './bp-mui-dropdown.component.html',
  styleUrls: ['./bp-mui-dropdown.component.scss']
})
export class BpMuiDropdownComponent implements OnInit {

  @Input() labelText = 'Select';

  @Input() showLabel = true;

  @Input() value = 'Select';

  showDropDown = false;

  staticText: any;

  @Input() enableToggle = true;

  /**
   * Property to hold option values in object format
   * Title is key used to display the property in dropdown
   */
  @Input() optionList = [{ title: '1', value: '1', disabled: false }, { title: '2', value: '2', disabled: false }];

  /**
   * Property to emit selected option value to parent comp
   */
  @Output() clickEvent = new EventEmitter<any>();

  @Output() searchEvent = new EventEmitter<any>();

  @Input() noOptionsText = 'No options available';

  constructor() { }

  ngOnInit(): void {
  }

  onSelectionChange(item, index: number) {
    this.value  = item.value;
    this.clickEvent.emit({item, index});
  }
}
